'use strict';

var namespace = 'productDiscoverability:';

module.exports = {
  CATEGORY_CHANGED: namespace + 'CATEGORY_CHANGED',
  VARIANT_CHANGED:  namespace + 'VARIANT_CHANGED',
  TAGS_CHANGED:      namespace + 'TAGS_CHANGED'
};
